import './TWTooltip.scss'
const TWTooltip = ({ text, children }) => {
	return (
		<span className="tooltip">
			<div className="tooltip__text">
				<span className="tooltip__triangle" />
				<span>{text}</span>
			</div>
			{children}
		</span>
	)
}
export default TWTooltip